(function () {
  'use strict';

  angular.module('tf.retailer.Util')
      .factory('GaUtil', GaUtil);

  function GaUtil($window, Api) {

    var gaTrackingId;

    return {
      sendGaEvent: sendGaEvent,
      sendGaPageView: sendGaPageView,
      createGaTracker: createGaTracker,
      setGaDimension: setGaDimension
    };

    function loadGaId() {
      return Api.get('/ga-id',{cache : true}).then(function(apiData){
        if(apiData.status == 200){
          return apiData.data;
        }
      });
    }

    function sendGaEvent(eventCategory, eventAction, eventLabel, isInteractive) {
      if(gaTrackingId){
        $window.ga('send', 'event', {
          eventCategory: eventCategory,
          eventAction: eventAction,
          eventLabel: eventLabel,
          nonInteraction: isInteractive || true
        });
      }
    }

    function sendGaPageView(title,pagePath) {
      if(gaTrackingId){
        $window.ga('send', 'pageview',{
          title : title,
          page : location.pathname + pagePath
        });
      }
    }

    function createGaTracker() {
      loadGaId().then(function(gaId){
        if(gaId){
          gaTrackingId = gaId;
          $window.ga('create',{
            trackingId : gaTrackingId,
            cookieDomain : 'auto'
          });
        }
      });
    }

    function setGaDimension(dimension, value) {
      if(gaTrackingId && value){
        $window.ga('set',dimension, value.toString());
      }
    }

  }
})();